export { default as IconAccessRestricted } from './IconAccessRestricted'
